export const DataFields = (t) => {
  return [
    {
      name: "",
      fields: [
        {
          id: "name",
          name: t('company_form_name'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "address",
          name: t('company_form_address'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "image",
          name: t('company_form_image'),
          type: "image",
          required: false,
          isImage: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "active",
          name: t('company_form_active'),
          type: "switch",
          required: true,
          defaultValue: false,
          size: "small"
        },
      ]
    }
  ]
}